export default __webpack_public_path__ + "static/media/Chainsaw.256.789afc5b.png";